import { render, staticRenderFns } from "./item_stock.vue?vue&type=template&id=968f4088&"
import script from "./item_stock.vue?vue&type=script&lang=js&"
export * from "./item_stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports